import { useFetchImages } from '../hooks/useFetchImages' // Custom hook c/ la lógica
import Card from './Card'
import FormIMGS from './FormIMGS'

const Cards = () => {

    const [images, handleSubmit, loadingYESorNO] = useFetchImages();

    
    return (
        <>
            <FormIMGS handleSubmit={handleSubmit} />

            { loadingYESorNO() }
            

            <div className="row">
                { //EJ: Itero el array con todas las IMG, y a cada uno le hago una Card.
                images.map((cadaImagenDelArray)=>{
                    return <Card img={cadaImagenDelArray.urls.regular} key={cadaImagenDelArray.id}/>
                })
                }
            </div>
        </>
    )
}

export default Cards
